import { EditClientReminder } from '../../../features/reminders/EditClientReminder';
import {
  compose,
  withAuthorized,
  withBaseLayout,
  withHelmet
} from '../../../core';

export const EditClientReminderPage = compose(
  withAuthorized,
  withBaseLayout,
  withHelmet({
    title: 'Splashworks: Reminders'
  })
)(EditClientReminder);
